/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_NumberInputs */

const en_sort_number = /** @type {(inputs: Sort_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number`)
};

const de_sort_number = /** @type {(inputs: Sort_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nummer`)
};

/**
* | output |
* | --- |
* | "Number" |
*
* @param {Sort_NumberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sort_number = /** @type {((inputs?: Sort_NumberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_NumberInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sort_number(inputs)
	return en_sort_number(inputs)
});